import React from "react";
import { Link } from "react-router-dom";

// Reuses the same visual pattern as the original HRHome.jsx tile grid,
// generalized to work for any department. Icons are optional per-item;
// falls back to a generic folder icon so new items don't need one
// assigned right away.
//
// Items are [label, to, description]. Pass `items` for a single grid, or
// `sections` ([{ heading, items }]) to group cards under headings.
const DEFAULT_ICON = "📁";

function CardGrid({ items, icons }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {items.map(([label, to, description]) => (
        <Link
          key={to}
          to={to}
          className="bg-white rounded-lg shadow-sm p-5 hover:shadow-md transition-shadow flex flex-col items-start border-l-4"
          style={{ borderColor: "#154E93" }}
        >
          <span className="text-2xl mb-2">{icons[label] || DEFAULT_ICON}</span>
          <span className="font-semibold" style={{ color: "#154E93" }}>{label}</span>
          {description && <span className="text-xs text-gray-400 mt-1">{description}</span>}
        </Link>
      ))}
    </div>
  );
}

export default function DepartmentHome({ title, description, items, sections, icons = {} }) {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-1" style={{ color: "#154E93" }}>{title}</h1>
      {description && <p className="text-sm text-gray-500 mb-6">{description}</p>}
      {sections
        ? sections.map((section) => (
            <div key={section.heading} className="mb-8">
              <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-3">{section.heading}</h2>
              <CardGrid items={section.items} icons={icons} />
            </div>
          ))
        : <CardGrid items={items} icons={icons} />}
    </div>
  );
}
